import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/core/core/node_modules/@mui/material/CssBaseline/CssBaseline.js");
